/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-promise-executor-return */
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getToken } from '../app/api/token';

dayjs.extend(utc);

export function getPaths(location) {
  const loc = location || window.location;
  const pathname = loc ? loc.pathname || '' : '';
  const paths = pathname.split('/');
  const params = {};
  loc.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    params[key] = decodeURIComponent(decodeURIComponent(value.toString()));
  });

  return {
    pathname,
    paths,
    params,
  };
}

export const isPublicPath = (path) => {
  return !path.includes('/elearning');
};

export function shouldUseMock() {
  return (
    process.env.REACT_APP_DEPLOY_ENV === 'LOCAL' &&
    Number(process.env.REACT_APP_ENABLE_MOCK) === 1
  );
}

export function shouldUseMaintenance() {
  return Number(process.env.REACT_APP_ENABLE_MAINTENANCE) === 1;
}

export function convertDuration(time, short = false) {
  if (typeof time !== 'number') return '-';
  if (time < 60) {
    return `${Math.round(time)} min`;
  }
  if (short) return `${Math.round(time / 60)}H`;

  const day = Math.floor(time / 60 / 24);
  if (day > 1) return `${day} giorni`;
  if (day === 1) return `${day} giorno`;
  const h = Math.floor(time / 60);
  const mm = Math.round(time % 60);
  return `${h}h ${mm ? `${mm}min` : ''}`;
}

export function get(time) {
  if (time > 60) {
    return dayjs.utc(time * 1000).format('m');
  }
  return (Number(time) / 60).toFixed(2);
}

export const defaultMandatoryStatusList = [
  { value: 'empty', label: 'statusEmpty' },
  { value: 'started', label: 'statusStarted' },
  { value: 'completed', label: 'statusCompleted' },
  { value: 1, label: 'statusExpiring' },
];

export const defaultCompletionStatusList = [
  { value: 'empty', label: 'statusEmpty' },
  { value: 'incomplete', label: 'statusIncompleted' },
  { value: 'completed', label: 'statusCompleted' },
];

export const defaultCourseStatusList = [
  { value: 'active', label: 'statusActive' },
  { value: 'expiring', label: 'statusExpiring' },
  { value: 'expired', label: 'statusExpired' },
];

export const dateFormat = (date = dayjs()) =>
  dayjs(date).format('DD/MM/YYYY') !== 'Invalid date'
    ? dayjs(date).format('DD/MM/YYYY')
    : date;

export const dateFormatCalendar = (date) =>
  dayjs(new Date(date)).format('D MMMM');

export const eventBus = {
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },
};

export const timestampToDate = (
  timestamp,
  format = 'DD/MM/YYYY',
  fullTimestamp = false
) => {
  if (
    (typeof timestamp !== 'number' && typeof timestamp !== 'string') ||
    timestamp === 0
  ) {
    return '-';
  }
  if (fullTimestamp) return dayjs(timestamp).format(format);
  return dayjs(timestamp * 1000).format(format);
};

const nameSorting = (users = []) =>
  users.sort((a, b) => {
    // Ordina per first_name
    const firstNameComparison = a.first_name.localeCompare(b.first_name);
    // Se i first_name sono diversi, restituisci il risultato del confronto per i first_name
    if (firstNameComparison !== 0) {
      return firstNameComparison;
    }
    // Se i first_name sono uguali, ordina per last_name
    return a.last_name.localeCompare(b.last_name);
  });

export const objectArraySorting = (array = [], key) => {
  if (key === 'first_name') {
    nameSorting(array);
    return;
  }
  if (array?.length <= 0 || !array[0][key]) return array;
  array.sort((a, b) => {
    if (typeof a[key] === 'number') {
      return b[key] - a[key];
    }
    if (typeof a[key] === 'string') {
      return a[key]?.toLowerCase() < b[key]?.toLowerCase()
        ? -1
        : a[key]?.toLowerCase() < b[key]?.toLowerCase()
        ? 1
        : 0;
    }
    if (a[key]?.value) {
      return a[key].value < b[key]?.value
        ? -1
        : a[key].value < b[key]?.value
        ? 1
        : 0;
    }

    //default
    return 0;
  });
};

export const toPercentage = (x = 0, y = 1) => {
  if ((!x && x !== 0) || !y) return 'n.d.';
  return `${Math.round((x / y) * 100)}%`;
};

export const getSessionPlace = (activity) => {
  if (activity.type === 'activity_session_virtual_room') return 'Online';
  if (activity.type === 'activity_session_in_place_room') {
    return activity?.address || 'In sede';
  }
  return '';
};

export const formatActivityInfo = (activity = {}) => {
  const now = dayjs().unix();
  const tsStart = dayjs(
    `${activity.date}+${activity.start_time}`,
    'YYYY-MM-DD+HH:mm'
  ).unix();
  const tsEnd = dayjs(
    `${activity.date}+${activity.end_time}`,
    'YYYY-MM-DD+HH:mm'
  ).unix();
  if (!tsStart || !tsEnd) return {};
  const info = {
    tsStart,
    tsEnd,
    isLive: tsStart < now && now < tsEnd,
    duration: `${Math.round((tsEnd - tsStart) / 3600)}H`,
  };
  return info;
};

export const getUrlWithToken = (url = '') => {
  if (!url?.includes('{JWT_USER_TOKEN}')) return url;
  const { token } = getToken();
  const newUrl = url.replace('{JWT_USER_TOKEN}', token);
  return newUrl;
};
